import URL from '../api_url';

export const CEP_API = `${URL}/external-apis/cep`;
